export enum PaymentStatus {
  Paid = 'paid',
  NotPaid = 'not_paid',
  Pending = 'pending',
  AutoRetry = 'auto_retry',
  Failed = 'failed',
  RequiresFunding = 'requires_funding',
  WaitingForFunding = 'waiting_for_funding',
  RolledUpToMaster = 'rolled_up_to_master',
  Voided = 'voided',
}

export enum SinglePaymentInvalidReason {
  HasUnprocessed = 'has_unprocessed_payments',
  HasAlreadyProcessed = 'has_already_processed_payment',
}

export enum SingleFailureReasonType {
  Unknown = 'unknown',
  BadPayment = 'bad_payment',
  ContractorNotOnboarded = 'contractor_not_onboarded',
  ContractorDeactivated = 'contractor_deactivated',
  NoValidPaymentMethod = 'no_valid_payment_method',
  UnsuccessfulPaymentAttempt = 'unsuccessful_payment_attempt',
  PaymentCanceled = 'payment_canceled',
}

export enum EarningPaymentMethod {
  Ach = 'ach',
  Instant = 'instant',
}

export enum FundingInvoiceStatus {
  Created = 'created',
  Pending = 'pending',
  Canceled = 'canceled',
  Failed = 'failed',
  Declined = 'declined',
  Confirmed = 'confirmed',
  Funded = 'funded',
}

export enum FundingType {
  Wire = 'wire',
  Loan = 'loan',
}

export enum FundingInvoiceExternalStatus {
  New = 'NEW',
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  PartiallyPaid = 'PARTIALLY_PAID',
  PaidInFull = 'PAID_IN_FULL',
  PaymentScheduled = 'PAYMENT_SCHEDULED',
}

export enum LoanFundingStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Processed = 'PROCESSED',
  Succeeded = 'SUCCEEDED',
  Failed = 'FAILED',
  Corrected = 'CORRECTED',
  Canceled = 'CANCELED',
  Error = 'ERROR',
}

export enum PaymentsTableFields {
  partnerDriverExternalId = 'partnerDriverExternalId',
  name = 'name',
  marketName = 'marketName',
  onboardingFlow = 'onboardingFlow',
  uploadedAt = 'uploadedAt',
  status = 'status',
  paidAt = 'paidAt',
  payoutMethod = 'payoutMethod',
  paid_to = 'paid_to',
  amount = 'amount',
  netAmount = 'netAmount',
}
